import alt from "../alt";
import BulkImportUtil from "../utils/BulkImportUtil";
import BulkImportActions from "../actions/BulkImportActions";
import UserStore from "../stores/UserStore";

class BulkImportStore {
  constructor() {
    this.bindActions(BulkImportActions);
    this.state = {
      isImporting: false,
      importCompleted: false,
      importSuccessful: false,
      importMessage: "",
      importOrder: null,
      previewData: null
    };
  }

  onReset() {
    this.setState({
      isImporting: false,
      importCompleted: false,
      importSuccessful: false,
      importMessage: "",
      importOrder: null,
      previewData: null
    });
  }

  onImportPasses({
    eventBucket,
    passBucket,
    extraMessage,
    preview,
    csvFile,
    noEmail
  }) {
    this.setState({
      isImporting: true
    });

    BulkImportUtil.importPasses(
      UserStore.getState().apiKey,
      eventBucket,
      passBucket,
      extraMessage,
      csvFile,
      noEmail,
      preview
    )
      .then(result => {
        if (!preview) {
          window.Intercom("trackEvent", "bulk-import-passes");
        }

        this.setState({
          isImporting: false,
          importCompleted: true,
          importSuccessful: result.success,
          previewData: preview ? result.preview_data : null,
          importMessage: result.message,
          importOrder: !preview ? result.order : null
        });
      })
      .catch(e => {
        this.setState({
          isImporting: false,
          importCompleted: true,
          importSuccessful: false,
          previewData: null,
          importMessage: e.message
        });
      });
  }

  onImportEvents({ eventBucket, preview, csvFile, virtual }) {
    this.setState({
      isImporting: true
    });

    BulkImportUtil.importEvents(
      UserStore.getState().apiKey,
      eventBucket,
      csvFile,
      preview,
      virtual
    )
      .then(result => {
        if (!preview) {
          window.Intercom("trackEvent", "bulk-import-events");
        }

        this.setState({
          isImporting: false,
          importCompleted: true,
          importSuccessful: true,
          previewData: preview ? result.preview_data : null,
          importMessage: result.message
        });
      })
      .catch(e => {
        this.setState({
          isImporting: false,
          importCompleted: true,
          importSuccessful: false,
          previewData: null,
          importMessage: e.message
        });
      });
  }

  onImportFilms({ eventBucket, preview, csvFile }) {
    this.setState({
      isImporting: true
    });

    BulkImportUtil.importFilms(
      UserStore.getState().apiKey,
      eventBucket,
      csvFile,
      preview
    )
      .then(result => {
        if (!preview) {
          window.Intercom("trackEvent", "bulk-import-films");
        }

        this.setState({
          isImporting: false,
          importCompleted: true,
          importSuccessful: true,
          previewData: preview ? result.preview_data : null,
          importMessage: result.message
        });
      })
      .catch(e => {
        console.error(e);
        this.setState({
          isImporting: false,
          importCompleted: true,
          importSuccessful: false,
          previewData: null,
          importMessage: e.message
        });
      });
  }

  onImportPeople({
    eventBucket,
    subjectLine,
    introMessage,
    extraMessage,
    preview,
    skipExisting,
    csvFile
  }) {
    this.setState({
      isImporting: true
    });

    BulkImportUtil.importPeople(
      UserStore.getState().apiKey,
      eventBucket,
      subjectLine,
      introMessage,
      extraMessage,
      csvFile,
      preview,
      skipExisting
    )
      .then(result => {
        if (!preview) {
          window.Intercom("trackEvent", "bulk-import-people");
        }

        this.setState({
          isImporting: false,
          importCompleted: true,
          importSuccessful: result.success,
          previewData: preview ? result.preview_data : null,
          importMessage: result.message
        });
      })
      .catch(e => {
        this.setState({
          isImporting: false,
          importCompleted: true,
          importSuccessful: false,
          previewData: null,
          importMessage: e.message
        });
      });
  }
}

export default alt.createStore(BulkImportStore, "BulkImportStore");



// WEBPACK FOOTER //
// ./src/app/stores/BulkImportStore.js